<script setup>
import { ref, computed,watch } from 'vue';
import { useQuasar, QVideo } from 'quasar';
const $q = useQuasar();
const isLargeScreen = computed(() => $q.screen.gt.xs);
const videoVisible = ref(false);

const darkMode = ref($q.dark.isActive);

watch(() => $q.dark.isActive, (newVal) => {
  darkMode.value = newVal;
})

useHead({
    title: 'Press',
    meta: [
        { name: 'description', content: 'News articles about OnSight Optical.' }
    ]
})
</script>

<template>
    <div class="row justify-center q-mt-lg q-mb-lg" style="margin-top: 40px;">
        <div class="col-11 col-md-6">
            <nuxt-link to="/article/AR-Customer-Conversations-OnSight-Optical" class="no-decoration">
                <q-card class="my-card q-mb-lg" :class="darkMode ? 'bg-grey-8 text-grey-4' : 'bg-white text-brand'" :style="{ borderRadius: '15px' }">
                    <q-card-section>
                        <div class="text-h4 text-left"><strong>Customer Conversations - OnSight Optical</strong>
                        </div>
                        <div class="text-h5 text-left">By Automation & Robotics </div>
                        <div class="text-h5 text-left">Automation & Robotics - November 26, 2020</div>
                    </q-card-section>
                    <q-card-section class="q-pt-none q-mt-auto" style="padding-left: 20px; padding-right: 20px;">
                        <p style="font-size: 20px;">
                            OnSight invested in the first A&R ProMapper Block, an easy-to-use table-top solution
                            providing optical inspection according to industry standards. <br> (continued...)
                        </p>
                    </q-card-section>
                </q-card>
            </nuxt-link>
            <nuxt-link to="/article/Essilor-2019-Awards" class="no-decoration">
                <q-card class="my-card q-mb-lg" :class="darkMode ? 'bg-grey-8 text-grey-4' : 'bg-white text-brand'" :style="{ borderRadius: '15px' }">
                    <q-card-section>
                        <div class="text-h4 text-left"><strong>Recognizing Independent Labs That Stand Out</strong>
                        </div>
                        <div class="text-h5 text-left">By Essilor News</div>
                        <div class="text-h5 text-left">Essilor News - 2019</div>
                    </q-card-section>
                    <q-card-section class="q-pt-none q-mt-auto" style="padding-left: 20px; padding-right: 20px;">
                        <p style="font-size: 20px;">
                            IDD Presents Awards at National Sales Meeting 2019 <br><br> (continued...) 
                        </p>
                    </q-card-section>
                </q-card>
            </nuxt-link>
            <nuxt-link to="/article/Technology-Transformations-OnSight-Optical" class="no-decoration">
                <q-card class="my-card q-mb-lg" :class="darkMode ? 'bg-grey-8 text-grey-4' : 'bg-white text-brand'" :style="{ borderRadius: '15px' }">
                    <q-card-section>
                        <div class="text-h4 text-left"><strong>Technology Transformations: OnSight Optical</strong>
                        </div>
                        <div class="text-h5 text-left">By Andrew Karp </div>
                        <div class="text-h5 text-left">Vision Monday - June 19, 2006</div>
                    </q-card-section>
                    <q-card-section class="q-pt-none q-mt-auto" style="padding-left: 20px; padding-right: 20px;">
                        <p style="font-size: 20px;">
                            CLEARWATER, Fla.--OnSight Optical provides its customers with what its founder and chief
                            executive officer Mike Shane calls a “holistic” service. <br> (continued...)
                        </p>
                    </q-card-section>
                </q-card>
            </nuxt-link>
            <nuxt-link to="/article/OnSight-Optical-Brings-Dispensing-Directly-To-MDs" class="no-decoration">
                <q-card class="my-card q-mb-lg" :class="darkMode ? 'bg-grey-8 text-grey-4' : 'bg-white text-brand'" :style="{ borderRadius: '15px' }">
                    <q-card-section>
                        <div class="text-h4 text-left"><strong>OnSight Optical Brings Dispensing Directly to
                                MDs</strong>
                        </div>
                        <div class="text-h5 text-left">By Cathy Ciccolella</div>
                        <div class="text-h5 text-left">Vision Monday - September 18, 1995</div>
                    </q-card-section>
                    <q-card-section class="q-pt-none q-mt-auto" style="padding-left: 20px; padding-right: 20px;">
                        <p style="font-size: 20px;">
                            FLORIDA OPHTHALMOLOGISTS looking for a quick entry into eyewear dispensing now have a new
                            option: OnSight Optical, launched last spring, has begun opening dispensaries in
                            ophthalmology
                            practices in the state’s Tampa Bay region. (continued...)
                        </p>
                    </q-card-section>
                </q-card>
            </nuxt-link>
        </div>
    </div>
</template>

<style scoped>
.no-decoration {
    text-decoration: none;
}
</style>